document.querySelectorAll("[data-exclusive-details]").forEach((group) => {
  group.addEventListener("toggle", (event) => {
    const active = event.target;
    if (!(active instanceof HTMLDetailsElement) || !active.open) return;

    group.querySelectorAll("details[open]").forEach((details) => {
      if (details !== active) details.open = false;
    });
  }, true);
});
